import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const RaintreeIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props}>
    <path
      d="M16.584 3.225c5.999.304 10.77 5.265 10.77 11.34l-.015.583c-.292 5.75-4.861 10.368-10.589 10.742v2.957h-1.5V25.89c-5.728-.374-10.298-4.992-10.59-10.743l-.014-.583C4.646 8.294 9.729 3.209 16 3.209l.584.016ZM16 4.71c-5.442 0-9.854 4.412-9.854 9.854 0 5.19 4.013 9.438 9.104 9.822v-1.264a8.593 8.593 0 0 1-7.833-8.116l-.01-.443A8.594 8.594 0 0 1 16 5.97l.442.01a8.595 8.595 0 0 1 8.152 8.583l-.012.443a8.594 8.594 0 0 1-7.832 8.117v1.263c5.091-.384 9.103-4.632 9.104-9.821 0-5.443-4.412-9.855-9.854-9.855Zm-.01 2.76a7.094 7.094 0 0 0-.74 14.147V19.99a4.567 4.567 0 0 1-3.817-4.505c0-.708.306-1.53.671-2.284.379-.781.876-1.6 1.362-2.337a38.72 38.72 0 0 1 1.78-2.468l.124-.158.034-.043.01-.01.002-.003.001-.001.573-.711Zm.594.71.001.002.002.003.01.01.033.043.125.158a38.74 38.74 0 0 1 1.78 2.468c.486.736.983 1.556 1.361 2.337.366.755.672 1.576.672 2.284a4.569 4.569 0 0 1-3.818 4.505v1.627a7.095 7.095 0 0 0-.741-14.147l.575.71ZM16 9.877c-.351.467-.818 1.11-1.283 1.814-.468.709-.925 1.466-1.263 2.163-.35.725-.521 1.285-.521 1.631a3.068 3.068 0 0 0 6.135 0c0-.346-.172-.906-.522-1.63-.338-.698-.795-1.455-1.263-2.164A37.277 37.277 0 0 0 16 9.877Z"
      fill={preserveColor ? "url(#raintree-gradient)" : undefined}
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="raintree-gradient"
        x1="4.646"
        x2="26.384"
        y1="13.838"
        y2="13.838"
      >
        <stop offset=".043" stopColor="#F29A20" />
        <stop offset=".082" stopColor="#D6652E" />
        <stop offset=".197" stopColor="#B9303B" />
        <stop offset=".365" stopColor="#5E115E" />
        <stop offset=".538" stopColor="navy" />
        <stop offset="1" stopColor="navy" />
      </linearGradient>
    </defs>
  </BaseIcon>
);
